var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { sizeMapping } from './sizeMapping';
import { commonStyle } from '../../utils/commonStyle';
import { margin } from '../../utils/margin';
import { Icon } from '../Icon/Icon';
import { CircularLoader } from '../Loader/CircularLoader';
import { useTheme } from '../ThemeProvider/useTheme';
export const DEFAULT_SIZE = 48;
const StyledButton = styled.button `
  ${commonStyle};
  margin: 0;

  font-family: inherit;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'inherit')};
  padding: 12px 24px 12px 24px;
  display: ${({ fullWidth }) => (fullWidth ? 'flex' : 'inline-flex')};
  justify-content: ${({ justifyContent, fixedIcon }) => justifyContent ? justifyContent : fixedIcon ? 'space-between' : 'center'};
  align-items: center;
  font-weight: 500;
  box-sizing: border-box;

  text-decoration: none;
  color: ${({ theme }) => theme.colors.content.above.secondary};
  background: ${({ theme }) => theme.colors.interactive.secondary.default};
  border: none;

  &:hover {
    background: ${({ theme }) => theme.colors.interactive.secondary.hover};
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0px 0px 0px 3px
        ${({ theme }) => theme.colors.background.default},
      0px 0px 0px 5px ${({ theme }) => theme.colors.content.default};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.background.contrast};
    color: ${({ theme }) => theme.colors.content.disabled};
    cursor: default;

    &:hover {
      background: ${({ theme }) => theme.colors.background.contrast};
    }
  }
  ${({ disabled, theme }) => disabled &&
    `
      background: ${theme.colors.background.contrast};
      color: ${theme.colors.content.disabled};
      cursor: default;
      pointer-events: none;

      &:hover {
        background: ${theme.colors.background.contrast};
      }

    `}

  ${margin};

  ${(props) => props.size && sizeMapping[props.size].style}
`;
const BaseButtonComponent = (_a, ref) => {
    var { children, fixedIcon, loading, size = DEFAULT_SIZE, component = 'button', startIcon, endIcon, color, disabled } = _a, props = __rest(_a, ["children", "fixedIcon", "loading", "size", "component", "startIcon", "endIcon", "color", "disabled"]);
    const iconSize = sizeMapping[size].iconSize;
    const theme = useTheme();
    const iconColor = disabled
        ? theme.colors.content.disabled
        : color || theme.colors.content.default;
    if (loading) {
        return (_jsx(StyledButton, Object.assign({ ref: ref, as: component, size: size, theme: theme, fixedIcon: fixedIcon }, props, { disabled: true, children: _jsx(CircularLoader, { size: iconSize, colorSet: "interactive.secondary.disabled" }) })));
    }
    return (_jsxs(StyledButton, Object.assign({ ref: ref, as: component, size: size, theme: theme, fixedIcon: fixedIcon, disabled: disabled, type: "button" }, props, { children: [startIcon && (_jsx(Icon, { name: startIcon, mr: children ? 8 : 0, color: iconColor, size: iconSize })), children, endIcon && (_jsx(Icon, { name: endIcon, ml: children ? 8 : 0, color: iconColor, size: iconSize }))] })));
};
export const BaseButton = forwardRef(BaseButtonComponent);
